import PropTypes from 'prop-types';
import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import VerifyPhone from 'assets/illustrations/Phone-and-Check.svg';

import useStyles from '../IdentityVerification/styles';

const VerifyPhoneSentForIdentityVerification = ({ phoneNumber, sendVerifyText }) => {
  const { classes } = useStyles();
  const theme = useTheme();

  return (
    <Box
      textAlign='center'
      pl={8}
      pr={8}
      pt={5}
      pb={5}
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
    >
      <img src={VerifyPhone} alt='phone-check' className={classes.thumbsUp} />
      <br />
      <Typography variant='headlineRegular'>We sent you a verification text.</Typography>
      <br />
      <Typography color='textSecondary' variant='paragraphRegular'>
        {`Tap the link sent to ${phoneNumber} We’ll  move on to the next step automatically.\n` +
          'If you don’t see the verification text soon, '}
        <Typography
          component='span'
          onClick={sendVerifyText}
          sx={{ color: theme.palette.primary.main, cursor: 'pointer' }}
          variant='inherit'
        >
          try resending it.&nbsp;
        </Typography>
      </Typography>
    </Box>
  );
};
VerifyPhoneSentForIdentityVerification.propTypes = {
  phoneNumber: PropTypes.string,
  sendVerifyText: PropTypes.func,
};

export default VerifyPhoneSentForIdentityVerification;
